<template>
  <div
    class="grid-area-shipping mod-small"
    @mouseover="isVisible = true"
    @mouseleave="isVisible = false"
  >
    <div class="grid-area-shipping mod-small">
      <div
        v-if="!updatedShippingEstimate.length || item.deliveryTimeRequest"
        class="grid-area-shipping__block grid-area-shipping__block--only-one"
      >
        <div class="grid-area-shipping__block-top-row">
          {{ shippingEstimate }}
        </div>
      </div>

      <div v-else class="grid-area-shipping__block">
        <div class="grid-area-shipping__block-top-row">
          {{ shippingEstimate }}

          <svg
            width="10"
            height="6"
            viewBox="0 0 12 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.13579 0.349188L0.33012 5.49934C-0.11004 5.97105 -0.11004 6.74416 0.33012 7.21587L0.731177 7.64568C1.17084 8.11739 1.89224 8.11739 2.3324 7.64568L6.00006 3.71618L9.66723 7.64622C10.1074 8.11793 10.8288 8.11793 11.2684 7.64622L11.6695 7.21641C12.1102 6.7447 12.1102 5.97158 11.6695 5.49987L6.86334 0.349725C6.62722 0.0961395 6.31038 -0.0166845 5.99956 0.00211961C5.68924 -0.0172214 5.37241 0.0956026 5.13579 0.349188Z"
              fill="#A9A9A9"
            />
          </svg>
        </div>

        <div
          v-if="isVisible && !item.deliveryTimeRequest"
          class="grid-area-shipping__block-content"
        >
          <div
            v-for="(shipping, i) in updatedShippingEstimate"
            :key="shipping.text + i"
            class="grid-area-shipping__block-content-row"
          >
            {{ shipping.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Shipping from "@/utils/shipping-estimate";

export default {
  name: "ShippingEstimate",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    marketArea: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isVisible: false
    };
  },
  computed: {
    shipping() {
      const copyOfItem = JSON.parse(JSON.stringify(this.item));
      const shipping = new Shipping(copyOfItem, this.marketArea, this.mess);

      shipping.filteringByMarketArea();
      shipping.mergingEstimates();

      return shipping;
    },
    shippingEstimate() {
      return this.shipping.getEstimate();
    },
    updatedShippingEstimate() {
      if (!this.item.shippingEstimate.length) return [];

      const shippings = this.shipping.getShippingEstimates();
      const totalCounts = shippings.reduce((sum, item) => {
        sum += parseInt(item.count);
        return sum;
      }, 0);
      const shipping_estimates = this.shipping.getShippingEstimates();

      if (totalCounts < this.item.qty) {
        const getNewEstimate = this.shipping.getNewEstimate(totalCounts);
        return [...shipping_estimates, ...[getNewEstimate]];
      }

      return shipping_estimates;
    }
  }
};
</script>

<style lang="scss">
.grid-area-shipping__block {
  width: 95%;
  position: relative;
  border: 1px solid gray;
  border-radius: 4px;
  padding: 0 8px;
  background-color: transparent;
  font-weight: 700;
  color: var(--v-primary-base);
  font-size: 10px;
  line-height: 24px;
  white-space: nowrap;
}

.grid-area-shipping__block.grid-area-shipping__block--only-one {
  border: none;
  padding: 0;

  .grid-area-shipping__block-top-row {
    cursor: auto;
  }
}

.grid-area-shipping__block:not(.grid-area-shipping__block--only-one) {
  @media (max-width: 768px) {
    min-width: 70px;
  }
}

.grid-area-shipping__block-top-row {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-top: 1px;
  padding-bottom: 1px;

  svg {
    margin-left: auto;
    transform: rotate(180deg);
  }
}

.grid-area-shipping__block-content {
  position: absolute;
  z-index: 1;
  width: calc(100% + 2px);
  top: 24px;
  left: -1px;
  background-color: #ffffff;
  border: 1px solid gray;
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 0 8px;
}

.grid-area-shipping__block-content-row {
  border-bottom: 1px solid #f5f5f5;
}
</style>
